import { Button } from '@design-system';
import { useTranslation } from 'next-i18next';
import React from 'react';

type Props = {
  onOpen: () => void;
};

export const OpenFiltersButton: React.FC<Props> = ({ onOpen }) => {
  const { t } = useTranslation('filters');

  return (
    <Button
      icon="ic_tune"
      label={t('filter')}
      onClick={() => onOpen()}
      size="md"
      variant="tertiary"
    />
  );
};

export default OpenFiltersButton;
